import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: BASE });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ec_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// GET returns the unwrapped `data` payload
export async function apiGet(path, params) {
  const { data } = await http.get(path, { params });
  return data?.data;
}

// mutations return full envelope {success, data, error}
export async function apiPost(path, body) {
  const { data } = await http.post(path, body);
  return data;
}

export async function apiPut(path, body) {
  const { data } = await http.put(path, body);
  return data;
}

export async function apiDelete(path) {
  const { data } = await http.delete(path);
  return data;
}

export function apiErrorMessage(e) {
  const d = e?.response?.data?.error;
  if (d?.message) return d.message;
  if (typeof e?.response?.data?.detail === "string") return e.response.data.detail;
  return e?.message || "Something went wrong. Please try again.";
}
